import { FormElement, FormType } from "../../components/enums";
import { isSectionVisible } from "../../components/formSettings.slice";
import { FormSchema, SimpleFormSchemaComponents } from "../../components/types";

import { ComponentId, SectionId } from "./enums";
import { selectWelcomeData, SelectRedirect } from "./welcome.selectors";
import { setIsClient, setOCType } from "./welcome.slice";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  redirect: SelectRedirect,
  selector: selectWelcomeData,
  content: [
    {
      sections: [
        {
          id: SectionId.WELCOME,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.IS_LEASE_CLIENT,
              required: true,
              label: "Prosimy o zaznaczenie właściwego pola:",
              onChange: setIsClient,
              //JIRA LPPLWEBMOB-740
              items: [
                {
                  label:
                    "Jestem Użytkownikiem pojazdu zarządzanego przez Ayvens",
                  description: "",
                  value: "true",
                },
                {
                  label:
                    "Zostałem poszkodowany przez pojazd Ayvens, ubezpieczony w Euro Insurances DAC",
                  description: "",
                  value: "false",
                },
              ],
            },
          ],
        },
        /*
        {
          id: SectionId.AC_VEHICLE_DRIVEABLE,
          wrapper: { xs: 12 },
          isVisible: isSectionVisible,
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.VEHICLE_DRIVEABLE,
              label: "Czy pojazd został odholowany?",
              required: true,
              onChange: setIsDriveable,
              items: [
                {
                  label: "tak",
                  value: "false",
                },
                {
                  label: "nie",
                  value: "true",
                },
              ],
            },
          ],
        },
        */
        {
          id: SectionId.OC_TYPE,
          wrapper: { xs: 12 },
          isVisible: isSectionVisible,
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.OC_TYPE,
              label: "Czego dotyczy zgłoszenie",
              required: true,
              onChange: setOCType,
              items: [
                {
                  label: "Pojazd",
                  value: FormType.OC_VEHICLE,
                },
                {
                  label: "Uszkodzone mienie",
                  value: FormType.OC_PROPERTY,
                },
                {
                  label: "Szkoda na osobie",
                  value: FormType.OC_PERSON,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
